// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bed4c57a","239":"92aa971f","488":"8ea13a6c","732":"aab40268"}[chunkId] + ".chunk.js";
};